<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
      page: {
         title: "Token Calls",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Token Calls",
            items: [
               {
                  text: "Token Calls",
                  active: true,
               },
            ],

            details: null,
            calls: [],
            counters: [],

            date: current_date,
            counter_id: "",
            keyword: "",
            listing_length: 10,

            pagination: {},
            from: "",
            to: "",
            total: "",

            token: "",
            errors: {},
            loading: false,
            active_page_url: null,
         };
      },
      computed: {
         moduleType() {
            // type 1 = lab, type 2 = pharmacy
            return this.$route.meta.moduleType || (this.$route.name === 'labs.tokenCalls' ? 1 : 2);
         },
         entityId() {
            return this.$route.params.id;
         },
         entityName() {
            if (!this.details) return "";
            return this.moduleType == 2
               ? this.details.pharmacy_name
               : this.details.lab_name;
         },
      },
      created() {
         this.fetchCounters();
         this.fetchTokenCalls();
      },
      methods: {
         fetchTokenCalls(page_url = null) {
            this.getToken();
            this.errors = {};

            let url = "api/admin/outsourceTokenCalls?limit=" + this.listing_length
               + "&type=" + this.moduleType
               + "&date=" + this.date
               + "&counter_id=" + (this.counter_id || "")
               + "&keyword=" + encodeURIComponent(this.keyword || "");

            if (this.moduleType == 2) {
               url += "&pharmacy_id=" + this.entityId;
            } else {
               url += "&lab_id=" + this.entityId;
            }

            page_url = page_url || url;
            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  this.details = responseData.details;
                  this.calls = responseData.calls.data || [];
                  this.from = responseData.calls.from;
                  this.to = responseData.calls.to;
                  this.total = responseData.calls.total;
                  this.pagination = responseData.calls.links;

                  if (this.entityName) {
                     this.title = "Token Calls - " + this.entityName;
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if (typeof error.response.data.message === 'object') {
                           this.errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         fetchCounters() {
            this.getToken();

            let url = "api/admin/counters?limit=100&status=&keyword=";
            if (this.moduleType == 2) {
               url += "&type=2&pharmacy_id=" + this.entityId;
            } else {
               url += "&type=1&lab_id=" + this.entityId;
            }

            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  this.counters = (responseData.counters && responseData.counters.data)
                     ? responseData.counters.data
                     : [];
               })
               .catch((err) => console.log(err));
         },

         paginationUrl(page) {
            if (!page.url) return null;
            return page.url
               + "&limit=" + this.listing_length
               + "&type=" + this.moduleType
               + "&date=" + this.date
               + "&counter_id=" + (this.counter_id || "")
               + "&keyword=" + encodeURIComponent(this.keyword || "")
               + (this.moduleType == 2
                  ? "&pharmacy_id=" + this.entityId
                  : "&lab_id=" + this.entityId);
         },

         formatDateTime(dateString) {
            if (!dateString) return "-";
            const date = new Date(dateString);
            const day = date.getDate();
            const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(date);
            const year = date.getFullYear();
            const hours24 = date.getHours();
            const minutes = date.getMinutes();
            const hours12 = hours24 % 12 || 12;
            const ampm = hours24 >= 12 ? "PM" : "AM";
            return `${day} ${month} ${year}, ${hours12}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
         },

         getToken() {
            if (localStorage.getItem("medicino_admin")) {
               var medicino_admin = JSON.parse(localStorage.getItem("medicino_admin"));
               if (medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
      },
   }
</script>

<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <div class="row mb-3">
                     <div class="col-12">
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
                           <i class="bx bx-chevrons-left"></i> Back
                        </a>
                     </div>
                  </div>

                  <div class="row mb-3">
                     <div class="form-group col-lg-3">
                        <label>Date <span class="text-danger">*</span></label>
                        <input
                           type="date"
                           v-model="date"
                           class="form-control"
                           @change="fetchTokenCalls()"
                           :class="{ 'is-invalid': Boolean(errors.date) }"
                        >
                        <div v-for="(val, index) in errors.date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>

                     <div class="form-group col-lg-3">
                        <label>Counter</label>
                        <select class="form-control" v-model="counter_id" @change="fetchTokenCalls()">
                           <option value="">All</option>
                           <option v-for="counter in counters" :key="counter.id" :value="counter.id">
                              {{ counter.counter_name }}
                           </option>
                        </select>
                     </div>

                     <div class="form-group col-lg-3">
                        <label>Search</label>
                        <input
                           type="text"
                           class="form-control"
                           placeholder="Token / Counter"
                           v-model="keyword"
                           @keyup="fetchTokenCalls()"
                        >
                     </div>
                  </div>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length">
                           <label>
                              Show
                              <select class="form-control" v-model="listing_length" @change="fetchTokenCalls()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                                 <option value="25">25</option>
                              </select>
                              entries
                           </label>
                        </div>
                     </div>
                  </div>

                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="30%">Counter</th>
                              <th width="25%">Token</th>
                              <th width="25%">Called On</th>
                              <th width="20%">Date</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(calls.length)">
                           <tr v-for="call in calls" :key="call.id">
                              <td>
                                 {{ call.counter_name || "-" }}
                                 <span v-if="call.counter_prefix">({{ call.counter_prefix }})</span>
                              </td>
                              <td>{{ call.token || "-" }}</td>
                              <td>{{ formatDateTime(call.updated_at || call.created_at) }}</td>
                              <td>{{ call.call_date || "-" }}</td>
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="4" class="text-center">No Token Calls found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>

                  <caption
                     v-if="Boolean(calls.length)"
                     class="float-start mt-4 d-block d-lg-inline"
                  >
                     Showing {{ from }} to {{ to }} of {{ total }} entries
                  </caption>
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li
                        class="page-item"
                        v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
                        v-for="(page, index) in pagination"
                        :key="page.label"
                     >
                        <a
                           href="#"
                           class="page-link"
                           @click.prevent="page.url && fetchTokenCalls(paginationUrl(page))"
                        >
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length - 1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{ page.label }}</span>
                        </a>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
